@if (logoUrl) {
  <img class="center" alt="{{ tenant?.name }} Logo" [src]="logoUrl" />
} @else {
  <h1 class="center">{{ tenant?.name }}</h1>
}
<app-members-header-controls></app-members-header-controls>
